import Loader from "./Loader";

function Button({ text, onSubmit, loading = false }: { text: string; onSubmit: () => void; loading?: boolean }) {
  return (
    <button
      type="button"
      className="min-w-full disabled:bg-gray-300 rounded-lg bg-primary p-4 text-white font-semibold capitalize flex items-center justify-center flex-row"
      onClick={onSubmit}
      disabled={loading}
    >
      {loading ? <Loader /> : text}
    </button>
  );
}

export default Button;
